export const GET_RANKING_REQUEST = 'ranking/GET_RANKING_REQUEST';
export const GET_RANKING_SUCCESS = 'ranking/GET_RANKING_SUCCESS';
export const GET_RANKING_FAILURE = 'ranking/GET_RANKING_FAILURE';
